module.exports = __webpack_public_path__ + "static/Rozdzielna.com-00a3075f748c5e1baa67defb58abce8d.jpg";